import { render, staticRenderFns } from "./PostalCodeComponent.vue?vue&type=template&id=5304f0d6&scoped=true&"
import script from "./PostalCodeComponent.vue?vue&type=script&lang=js&"
export * from "./PostalCodeComponent.vue?vue&type=script&lang=js&"
import style0 from "./PostalCodeComponent.vue?vue&type=style&index=0&id=5304f0d6&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5304f0d6",
  null
  
)

export default component.exports